/* eslint-disable max-len */
import React from 'react';
import {CellProps} from 'react-table';
import styled from 'styled-components';

import {School} from '../../../../api/types';
import {LoadingView} from '../../../loading/loading';
import {useSchoolAcademicYearTableContext} from '../../hooks';
import {formatAcademicYearPeriod} from '../../../../helpers/format-academic-year-period';
import {VStack} from '../../../layout/layout.styled';
import {BlueButton} from '../../../blue-button/blue-button.styled';

export function AcademicYearCell ({ row: { original } }: CellProps<School>) {
    const academicYearPeriod = formatAcademicYearPeriod(original.academicYear || {})

    return <div>{academicYearPeriod}</div>;
}

export function YearNameCell ({ row: { original } }: CellProps<School>) {
    if (!original?.academicYear?.year) {
        return null;
    }

    return <div>{original.academicYear.year}</div>;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ChangeCell ({row: { original } }: CellProps<School>) {
    const { onOpenChangeSchool } = useSchoolAcademicYearTableContext();

    return <BlueButton
        onClick={() => {onOpenChangeSchool(original);}}
        hasFutureSchoolAcademicYear={original.hasFutureSchoolAcademicYear}
    >
        {original.hasFutureSchoolAcademicYear ? 'View' : 'Change'}
    </BlueButton>;
}

export const UpArrow = (props: React.ComponentProps<any>) => {
    return (
        <svg width="9px" height="6px" viewBox="0 0 9 6" {...props}>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none"
                fillRule="evenodd">
                <g id="Academic-year-01"
                    transform="translate(-411.000000, -391.000000)"
                    fill="#415567" fillRule="nonzero">
                    <g id="Icon/Sorting"
                        transform="translate(403.000000, 386.000000)">
                        <g id="Group-6"
                            transform="translate(8.000000, 5.000000)">
                            <g id="icon_arrow-copy"
                                transform="translate(4.500000, 3.000000) scale(1, -1) translate(-4.500000, -3.000000) ">
                                <path
                                    d="M8.8758804,5.07349666 L5.00091071,0.227171492 C4.75518093,-0.0757238307 4.26372136,-0.0757238307 4.01799158,0.227171492 L0.124119605,5.07349666 C-0.178317053,5.46547884 0.105217313,6 0.615579174,6 L8.38442083,6 C8.89478269,6 9.17831705,5.46547884 8.8758804,5.07349666 Z"
                                    id="icon_arrow_down"
                                    transform="translate(4.500000, 3.000000) scale(1, -1) translate(-4.500000, -3.000000)" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const DownArrow = styled(UpArrow)`
  transform: scaleY(-1);
`;

type SortArrowsIconProps = {
    up?: boolean
    down?: boolean
}

export const SortIconContainer = styled.div`
  display: flex;
  align-content: center;
`;

export const SortArrowsIcon = ({
    up = true, down = true
}: SortArrowsIconProps) => {
    return (
        <VStack spacing={'2px'} justifyContent={'center'}>
            {up ? <UpArrow/> : <UpArrow opacity={0}/>}
            {down ? <DownArrow/> : <DownArrow opacity={0}/>}
        </VStack>
    );
};

export const Container = styled.div<{isFetching: boolean, isPreviousData: boolean}>`
  overflow-x: auto;
  position: relative;
  border-left: 1px solid #E8EAEC;
  ${props => props.isFetching && props.isPreviousData ? `
    pointer-events: none;
    opacity: 0.3;
  `: null}
`;

export const TableElement = styled.table`
  font-family: ${props => props.theme.typography.fontFamily};
  border-spacing: 0;
  border: 1px solid #E8EAEC;
  border-left: none;
  width: 100%;

  & > thead > tr > th:last-child {
    position: sticky;
    right: 1px;
    background-color: #e7e9ea;
    box-shadow: 0 7px 7px 4px #ccc;
  }

  & > tbody > tr > td:last-child {
    box-shadow: 0 7px 7px 4px #ccc;
    position: sticky;
    right: 1px;
    background-color: white;
  }

  thead {
    tr {
      th {
        color: #415567;
        font-weight: 400;
        padding: 12px;
        border: 1px solid #DDDDDD;
        text-transform: uppercase;
      }
    }
  }

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  th,
  td {
    margin: 0;
    padding: 0.5rem;
    border-bottom: 1px solid #dfdfdf;
  }

  td {
    input {
      font-size: 1rem;
      padding: 0;
      margin: 0;
      border: 0;
    }
  }
`;

export const THead = styled.thead`
  background-color: #e7e9ea;
  border-color: #dfdfdf;
`;

export const LoadingSpinnerOverlay = styled(LoadingView)`
  position: absolute;
  margin-left: 50%;
  margin-top: 20%;
`
